<div class="mb-4" *ngIf="transportOrder">
  <div class="alert alert-warning" *ngIf="isDisplayADRWarning && !middleView">
    <span jhiTranslate="ALERT.WARNING.TRANSPORT_CONTAINS_HAZARDOUS_MATERIAL"></span>
    <a [href]="mailto" target="_blank" jhiTranslate="BTN.SEND_YOUR_DOCUMENT"></a>
  </div>
  <div *ngIf="trackAndTraceLink" class="mb-2">
    <span>{{ 'LABEL.COPY_TRACK_TRACE_LINK' | translate }}&nbsp;:</span>
    <jhi-bary-icon-button [outline]="true" [floating]="true" size="sm" icon="copy" (clickEvent)="copyLink()"></jhi-bary-icon-button>
  </div>
  <div class="mb-2" *jhiHasAnyAuthority="['ROLE_USER']">
    <jhi-bary-mailto
      [emailTransporter]="documentEmailTransporter"
      [type]="transportOrder.isHazardousMaterial ? LIST_MAILTO.ADD_DOCUMENT_ADR : LIST_MAILTO.ADD_DOCUMENT"
      labelkey="BTN.ATTACH_DOCUMENT"
      [params]="{ transportOrderView: transportOrder, transporterCompanyName: transporter?.companyName, user: userMinimal }"
    ></jhi-bary-mailto>
  </div>
  <jhi-transport-actions *jhiHasAnyAuthority="['ROLE_ADMIN', 'ROLE_MODERATOR']" [transportOrder]="transportOrder" [ediId]="ediId"></jhi-transport-actions>
  <jhi-transport-card [transport]="abstractTransport"></jhi-transport-card>
  <jhi-track-and-trace [transportOrder]="transportOrder" [savMail]="savMail" *ngIf="ediId && transportOrder.trackAndTrace" [transporter]="transporter!"></jhi-track-and-trace>
  <div class="row mb-4" *ngIf="transportOrder.pods && transportOrder.pods.length > 0">
    <div class="col-12">
      <jhi-bary-card titleKey="LABEL.PODS">
        <div body class="p-2">
          <div class="row">
            <div class="col p-2">
              <ng-container *ngFor="let pod of transportOrder.pods">
                <jhi-bary-button
                  label="{{ 'LABEL.POD_OF' | translate: { day: dayjs(pod.stepDate).toDate() | date: 'short' } }}"
                  (clickEvent)="openLink(pod.podUrl!)"
                  icon="eye"
                  class="mx-1"
                  size="sm"
                  color="main"
                ></jhi-bary-button>
              </ng-container>
            </div>
          </div>
        </div>
      </jhi-bary-card>
    </div>
  </div>
  <div class="row mb-4">
    <div class="col-6" *ngIf="transportOrder.basketOrder && transportOrder.basketOrder.id">
      <jhi-bary-card titleKey="LABEL.BILL" icon="file-invoice">
        <div class="row" body>
          <div class="col">
            <a (click)="clickToShowBill(transportOrder.basketOrder.id)" target="_blank">
              <jhi-bary-icon icon="eye" [faDirective]="FaDirectiveEnum.FAS" class="text-primary"></jhi-bary-icon>
              {{ 'BTN.SEE_BILL' | translate }}
            </a>
          </div>
        </div>
      </jhi-bary-card>
    </div>
    <div class="col-6" *ngIf="hasStickerFeature">
      <jhi-bary-card titleKey="LABEL.STICKER" icon="barcode">
        <div class="row" body>
          <div class="col">
            <!-- TODO: url issue in local -->
            <a [href]="PATHS.API_STICKER_VIEW.withId(transportOrder.id)" target="_blank">
              <jhi-bary-icon icon="eye" [faDirective]="FaDirectiveEnum.FAS" class="text-primary"></jhi-bary-icon>
              {{ 'BTN.SEE_STICKER' | translate }}
            </a>
          </div>
        </div>
      </jhi-bary-card>
    </div>
  </div>
  <div class="row mb-4">
    <div class="col-12">
      <jhi-bary-card titleKey="LABEL.TRANSPORT_INCIDENTS">
        <div body>
          <div class="row mt-2" *ngFor="let incident of incidents">
            <div class="col-auto h-100 my-auto">
              <jhi-bary-button
                class="incident-info btn-warning text-white"
                [disabled]="true"
                [tooltip]="'BTN.DELETE' | translate"
                icon="info"
                [floating]="true"
                size="lg"
                color="primary"
              ></jhi-bary-button>
            </div>
            <div class="card col border border-warning p-2">
              <div class="container-fluid">
                <div class="row">
                  <div class="col">
                    <h4 class="font-weight-bold">{{ incident.cause }}</h4>
                    <p class="text-muted" *ngIf="incident.date">
                      <jhi-bary-icon icon="clock" [faDirective]="FaDirectiveEnum.FAR" aria-hidden="true"></jhi-bary-icon>
                      {{ incident.date.toDate() | date: 'short' }}
                      <span *ngIf="middleView && incident.creatorLogin"> par {{ incident.creatorLogin }} </span>
                    </p>
                    <p *ngIf="incident.comment && incident.comment !== 'null'">
                      {{ incident.comment }}
                    </p>
                    <p *ngIf="!incident.comment || incident.comment === 'null'">
                      {{ 'TRANSPORT_INCIDENT.DEFAULT_MESSAGE' | translate }}
                    </p>
                    <p *ngIf="incident.additionalBasketOrderId && incident.additionalBasketOrderId != transportOrder.basketOrder?.id">
                      <a (click)="clickToShowBill(incident.additionalBasketOrderId)" target="_blank">
                        <jhi-bary-icon icon="eye" [faDirective]="FaDirectiveEnum.FAS" class="text-primary"></jhi-bary-icon>
                        {{ 'BTN.SEE_TRANSPORT_INCIDENT_BILL' | translate }}
                      </a>
                    </p>
                    <p *ngIf="!incident.additionalBasketOrderId" jhiTranslate="TRANSPORT_INCIDENT.IS_GOING_TO_BE_ADDED_TO_PRINCIPAL_BILL"></p>
                  </div>
                  <div class="col-auto h-100 my-auto">
                    <span class="font-weight-bold incident-amount" *ngIf="incident.incidentAmount"
                      >{{ incident.incidentAmount | currency: 'EUR' }} {{ 'SUFFIX.PRE_TAXES' | translate }}</span
                    >
                  </div>
                  <div class="col-auto h-100 my-auto" *ngIf="!transportOrder.basketOrder">
                    <jhi-bary-icon-button
                      color="danger"
                      icon="trash"
                      [tooltip]="'BTN.ADD_TRANSPORT_INCIDENT' | translate"
                      (click)="deleteIncident(incident.id)"
                    ></jhi-bary-icon-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="!isInitTransfertImmediate">
            <div class="row" *ngIf="!incidents || incidents.length === 0">
              <div class="col-12" jhiTranslate="LABEL.NO_TRANSPORT_INCIDENT"></div>
            </div>
            <div class="row pt-4" *ngIf="middleView && canDeclareIncident">
              <div class="col-12">
                <jhi-bary-button color="warning" [label]="'BTN.ADD_TRANSPORT_INCIDENT' | translate" icon="plus" (click)="openAddIncidentPopin()"></jhi-bary-button>
              </div>
            </div>
          </div>
          <div *ngIf="isInitTransfertImmediate">
            <div class="row">
              <div class="col-12" jhiTranslate="TRANSPORT_INCIDENT.MESSAGE_FOR_INIT_TRANSFERT"></div>
            </div>
          </div>
        </div>
      </jhi-bary-card>
    </div>
  </div>
</div>
